export default "skymp5-front/01904573869ab582ebcfdf12e510190b.png";